import { render, staticRenderFns } from "./HomeScreen.vue?vue&type=template&id=a1d7f4bc&scoped=true"
import script from "./HomeScreen.vue?vue&type=script&lang=js"
export * from "./HomeScreen.vue?vue&type=script&lang=js"
import style0 from "./HomeScreen.vue?vue&type=style&index=0&id=a1d7f4bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d7f4bc",
  null
  
)

export default component.exports